export default __webpack_public_path__ + "static/media/reveloTwitter-600x314.ca8f835d.jpg";